**Deprecated:** Use `associatedPositionProfile` instead.
